const pageRoutes = {
    home: '/',
    following: '/following',
    profile: '/@:nickname',
    upload: '/upload',
    search: '/search',
    live: '/live',
};

export default pageRoutes;